import React from 'react';
import Badge from '@material-ui/core/Badge';
export const DotBadge = (props) => {
    const { children, isShow } = props;
    return (React.createElement(Badge, { color: "secondary", variant: "dot", invisible: !isShow }, children));
};
